module.exports = __webpack_public_path__ + "static/media/best-place.d628e9c6.png";